<template>
    <div id="main-footer">
        <!--footer-->
        <footer class="col-12">
                <div class="row">
                    <a href="http://www.vvgcareers.com" target="_blank"><img src="/static/images/HR-walljobscenterroad.jpg"></a>
                </div>
        </footer>
        <!--<footer class="col-12">
            <div class="container">
                <div class="row">
                    <div class="footer-links col-12">
                        <div class="footer-link-1 col-12 col-sm-6 col-md-3 col-lg-3 border-right-blue">
                            <div class="row">
                                <ul class="snip1135">
                                    <li> <router-link v-bind:to="{ path:'/hrcalendar'}" data-hover="HR Calendar"> HR Calendar </router-link> </li>
                                    <li> <router-link v-bind:to="{ path:'/meethrteam'}" data-hover="Meet the HR Team"> Meet the HR Team </router-link> </li>
                                    <li> <router-link v-bind:to="{ path:'/formspolicies'}" data-hover="Policies and Forms"> Policies and Forms </router-link> </li>
                                </ul>
                            </div>
                        </div>
                        <div class="footer-link-1 col-12 col-sm-6 col-md-3 col-lg-3 border-right-blue">
                            <div class="row">
                                <div class="footer-center">
                                    <ul class="snip1135">
                                        <li> <router-link v-bind:to="{ path:'/benefits'}" data-hover="Benefits"> Benefits </router-link> </li>
                                        <li> <router-link v-bind:to="{ path:'/wellness'}" data-hover="Wellness"> Wellness </router-link> </li>
                                        <li> <router-link v-bind:to="{ path:'/surveys'}" data-hover="Surveys"> Surveys </router-link> </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="footer-link-1 col-12 col-sm-6 col-md-3 col-lg-3 footer-center border-right-blue">
                            <div class="row">
                                <div class="footer-center">
                                    <ul class="snip1135">
                                        <li> <router-link v-bind:to="{ path:'/gallery'}" data-hover="Gallery"> Gallery </router-link> </li>
                                        <li> <router-link v-bind:to="{ path:'/401kplan'}" data-hover="401K"> 401K </router-link> </li>
                                        <li> <router-link v-bind:to="{ path:'/contact'}" data-hover="Contact"> Contact </router-link> </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="footer-link-1 col-12 col-sm-6 col-md-3 col-lg-3 float-r footer-right">
                            <div class="row">
                                <ul class="snip1135 float-r">
                                    <template v-if="roleId <= 2">
                                        <li> <router-link v-bind:to="{ path:'/leadershipdevelopment'}" data-hover="Leadership and Development"> Leadership and Development </router-link> </li>
                                    </template>
                                    <li> <router-link v-bind:to="{ path:'/employeeperksprogram'}" data-hover="Employee Perks"> Employee Perks </router-link> </li>
                                    <li> <router-link v-bind:to="{ path:'/employeerecognition'}" data-hover="Employee Recognition"> Employee Recognition </router-link> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </footer>-->
        <!--footer bottom line-->
        <!--<section class="footer-bottom-line col-12">
            <div class="container">
                <div class="row">
                    <p> © {{system_year}} Velocity Vehicle Group </p>
                </div>
            </div>
        </section>-->
        <!--footer bottom line-->
        <!--footer-->
    </div>
</template>
<script>
    import index from "../../router";
    import EventBus from "../event-bus";
    import Vue from "vue";
    import SessioMixin from '../../mixins/sessionmixin';
    var self;
    export default {
        /*import * as mykey from '/static/js/jquery.rotateSlider.js',*/
        name: "Home",
        mixins: [SessioMixin],
        data() {
            return {
                isLoggedIn: false,
                isShowLoggedinfields: true,
                loginID: 0,
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',
            };
        },
        beforeMount: function () {
            self = this;
            var check = window.localStorage.getItem("api_token");

            if (check != null) {
                self.isLoggedIn = true;
            }
        },
        mounted: function () {
            self = this;
            self.getBuildVersion();
        },
        methods: {

        }
    };
    EventBus.$on('role', function (isLogin, id, name, system_year,userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.roleName = name;
            self.system_year = system_year;
            self.userPermissions = userPermissions;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue